import { ExpirationStatus } from 'src/lib/expirationTracking/expirationTracking'

export const getExpirationStatusColor = (
  status: ExpirationStatus
): string => {
  if (status === 'expired' || status === 'missing')
    return 'text-doubleNickel-error-500'
  if (status === 'expiring') return 'text-doubleNickel-warning-500'
  return 'text-doubleNickel-success-600'
}
